import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { CustomFloatingFilterProps } from 'ag-grid-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const startAdornment = (
    <InputAdornment position="start">
        <SearchIcon fontSize="small" sx={{ color: 'muiBlack' }} />
    </InputAdornment>
);

const StyTextField = styled(TextField, {
    name: 'StyTextField',
})({
    '& .MuiInputBase-input': {
        fontSize: '12px',
    },
    '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: '6px',
    },
    '& .MuiInputAdornment-positionStart': {
        marginRight: '4px',
    },
    width: '100%',
    alignSelf: 'center',
});

const DateFloatingFilter = ({
    model,
    onModelChange,
}: CustomFloatingFilterProps) => {
    const { t } = useTranslation();
    const onChange = ({
        target: { value: newValue },
    }: React.ChangeEvent<HTMLInputElement>) => {
        onModelChange(
            newValue === ''
                ? null
                : {
                      ...(model || { type: 'equals' }),
                      dateFrom: newValue,
                  },
        );
    };

    const dateValue = model?.dateFrom ? model.dateFrom.split(' ')[0] : '';

    return (
        <StyTextField
            value={dateValue}
            size="small"
            type="date"
            placeholder={t('common.searchPlaceholder')}
            InputProps={{
                startAdornment,
                disableInjectingGlobalStyles: true,
            }}
            onChange={onChange}
            variant="outlined"
        />
    );
};

export default DateFloatingFilter;
